import bizNodeModel from '../../bizNodeModel.mjs'
import SfType from './SfType.jsx'

export default bizNodeModel({
    fmCode: {
        name: () => '功能域',
    },

    sfNo: {
        name: () => '系统功能代码',
        required: () => true,
    },

    sfName: {
        name: () => '系统功能名称',
        required: () => true,
    },

    sfTypeCode: {
        disabled: (map, node) => node.data.pkid,
        name: () => '系统功能类型',

        readableValue: (map, node) => {
            const {sfTypeCode} = node.data

            if (sfTypeCode) {
                const match = SfType.find(e => sfTypeCode === e[0])

                if (match) {
                    return match[1]
                }
            }

            return ''
        },
        required: () => true,
    },

    sfKey: {
        name: () => '功能简述',
    },

    sfMemo: {
        name: () => '备注',
    },
})
